import React from 'react';
import { IComponentText } from '../../component';

import './text.scss';

const AllForText = function(props: IComponentText) {
  const { richtext } = props;
  return (
    <div className="all-for-text">
      <div
        className="html-rawdata"
        dangerouslySetInnerHTML={{ __html: richtext || '' }}
      ></div>
    </div>
  );
};

export default AllForText;
